module.exports = __webpack_public_path__ + "img/katherine-prescott-wormeley.4aa66cc9.png";